<template>
    <div class="fade-up my-4">
        <p
            v-if="question.explanation"
            class="mb-4"
        >
            {{ $t(question.explanation) }}
        </p>
        
        <b-row
            v-for="(s, i) in question.statements"
            :key="i"
            align-v="center"
            class="mb-5"
        >
            <b-col
                sm="6"
                class="mb-4 mb-sm-0"
            >
                <div 
                    class="bg-primary text-secondary p-3"
                    style="min-height: 10rem;"
                >
                    <h4 v-if="s.text">
                        {{ $t(s.text) }}
                    </h4>

                    <p
                        v-if="s.explanation"
                        class="mt-3"
                    >
                        {{ $t(s.explanation) }}
                    </p>
                </div>
            </b-col>

            <b-col sm="6">
                <vue-slider
                    v-model="subanswers[i]"
                    :min="s.slider.min"
                    :max="s.slider.max"
                    :marks="true"
                    :hide-label="true"
                    dot-size="auto"
                    :drag-on-click="true"
                    :height="8"
                    tooltip="none"
                >
                    <template #dot="{ value }">
                        <b-btn
                            variant="light"
                            size="sm"
                            class="btn-circle font-weight-bold"
                        >
                            {{ value }}
                        </b-btn>
                    </template>
                </vue-slider>

                <div class="small d-flex justify-content-between mt-3 mt-sm-4">
                    <span>{{ $t(`common.sliders.${s.slider.type}.labelMin`) }}</span>

                    <span>{{ $t(`common.sliders.${s.slider.type}.labelMax`) }}</span>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';

export default {
    name: 'StatementsSliders',
    components: { VueSlider },
    inheritAttrs: false,
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            subanswers: this.question.statements.map(
                s => Math.round((s.slider.min + s.slider.max) / 2),
            ),
        };
    },
    watch: {
        subanswers: {
            handler: function(val) {
                // If all statements have been answered, ...
                if (Object.keys(val).length === this.question.statements.length) {
                    // ... determine the answer and emit it.
                    this.$emit('input',
                        this.question.determineAnswer(this.getRealSubanswers()),
                    );
                }
            },
            immediate: true,
        },
    },
    methods: {
        getRealSubanswers() {
            return this.subanswers.map((s, i) => {
                const slider = this.question.statements[i].slider;

                if (slider.inverse) {
                    // Inverse value (1 becomes 7, 2 becomes 6, and so on).
                    return slider.max - s + slider.min; 
                }

                return s;
            });
        },
    },
};
</script>

<style lang="scss">
@import '@/assets/scss/vendors/_vue-slider';
</style>